import paginatedGrid from '../../../components/paginatedGrid.js';
import eventAgenda from '../../../components/eventAgenda.js';
import MicroModal from 'micromodal';

document.querySelectorAll('[data-paginated-grid]')
  .forEach(el => new paginatedGrid(el));

let modalOpen = false;
const modalConfig = {
  onShow: () => modalOpen = true,
  // prevent [enter] key from double-triggering the modal
  onClose: () => setTimeout(() => modalOpen = false, 300),
  openTrigger: 'data-modal-open',
  awaitCloseAnimation: true,
};

initModal(modalConfig);

new eventAgenda(document.querySelector('[data-event-agenda]'));

function initModal(modalConfig) {
  MicroModal.init(modalConfig);
  document.querySelectorAll('[data-modal-open]').forEach(el => {
    el.addEventListener('keyup', e => {
      if ([32, 13].includes(e.which) && !modalOpen) MicroModal.show(el.dataset.modalOpen, modalConfig);
    });
  });
}
